import { Route } from '@angular/router';
import { ActivitiesComponent } from './activities.component';

export const ActivitiesRoutes: Route = {
  path: '',
  component: ActivitiesComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'dashboard',
    },
    {
      path: 'dashboard',
      loadComponent: () => import('./components/activities-dashboard/activities-dashboard.component').then((m) => m.ActivitiesDashboardComponent),
    },
    {
      path: 'timeline',
      loadComponent: () => import('./components/activities-timeline/activities-timeline.component').then((m) => m.ActivitiesTimelineComponent),
    },
    {
      path: 'list',
      loadComponent: () => import('./components/activities-list/activities-list.component').then((m) => m.ActivitiesListComponent),
    },
  ],
};
